function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Actions } from "./actions";
import { NAVIGATION_MAX_DEPTH } from "./constants";
import { navigationItemBuilder } from "../../../../../builders/navigationItem";
var createPageFromNavigationItem = function createPageFromNavigationItem(item, index) {
  return _objectSpread(_objectSpread({}, item), {}, {
    index
  });
};
var createEmptyPages = function createEmptyPages(count, startIndex) {
  return Array.from({
    length: count
  }).map(function (_, i) {
    var index = startIndex + i;
    return _objectSpread(_objectSpread({}, navigationItemBuilder({
      title: "Empty page ".concat(index),
      level: 0
    })), {}, {
      index,
      isEmpty: true
    });
  });
};
export var getInitalState = function getInitalState(navigation) {
  return {
    currentPage: 0,
    pages: [createPageFromNavigationItem(navigation, 0)].concat(_toConsumableArray(createEmptyPages(NAVIGATION_MAX_DEPTH - 1, 1)))
  };
};
var handlers = {
  [Actions.GO_BACK]: function (state) {
    var previousPage = Math.max(state.currentPage - 1, 0);
    // remove unnecessary pages
    var pagesEnd = previousPage + 2;
    var pages = [].concat(_toConsumableArray(state.pages.slice(0, pagesEnd)), _toConsumableArray(createEmptyPages(NAVIGATION_MAX_DEPTH - pagesEnd, pagesEnd)));
    return _objectSpread(_objectSpread({}, state), {}, {
      pages,
      currentPage: previousPage
    });
  },
  [Actions.GOTO_ITEM]: function (state, action) {
    var _ref = action,
      item = _ref.payload.item;
    var nextPage = Math.min(state.currentPage + 1, NAVIGATION_MAX_DEPTH);
    var emptyPagesStart = nextPage + 1;
    var pages = [].concat(_toConsumableArray(state.pages.slice(0, nextPage)), [createPageFromNavigationItem(item, nextPage)], _toConsumableArray(createEmptyPages(NAVIGATION_MAX_DEPTH - emptyPagesStart, emptyPagesStart)));
    return _objectSpread(_objectSpread({}, state), {}, {
      currentPage: nextPage,
      pages
    });
  }
};
export var reducer = function reducer(state, action) {
  return handlers[action.type](state, action);
};